<template>
  <!-- Welcome content is rendered on the left panel by the onboarding layout -->
  <div />
</template>

<script setup lang="ts">
// Intentionally empty; left panel handles Welcome text & CTA
</script>
